import EmailCapture from "@/components/EmailCapture";
import { HeroLine, Reveal } from "@/components/Motion";

export default function AboutPage() {
  return (
    <>
      <section
        data-testid="about-hero-section"
        className="min-h-[62svh] flex items-end pb-20 md:pb-28"
        style={{ backgroundColor: "var(--paper)" }}
      >
        <div className="max-w-[1100px] w-full mx-auto px-6 md:px-12">
          <p className="overline mb-6 animate-overline">About</p>
          <h1
            data-testid="about-title"
            className="font-serif-lit text-5xl sm:text-6xl leading-[1]"
            style={{ color: "var(--ink)", fontWeight: 500 }}
          >
            <HeroLine delay={0.12}>Rahul</HeroLine>
            <HeroLine delay={0.24} className="italic">Bhaskar</HeroLine>
          </h1>
        </div>
      </section>

      <section
        data-testid="about-long-section"
        className="py-24 md:py-32"
        style={{ backgroundColor: "var(--paper-deep)" }}
      >
        <div className="max-w-[940px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20">
          <Reveal className="md:col-span-3">
            <p className="overline">The long version</p>
          </Reveal>
          <Reveal
            className="md:col-span-9 font-serif-lit text-xl md:text-2xl leading-[1.7] space-y-7"
            delay={0.08}
          >
            <p><em className="italic">Nothing in the Way</em> is the first book by Rahul Bhaskar — and the only thing he has ever written that took twenty years to be ready to write.</p>
            <p>He was born and raised in India and spent significant years in California, where the search began in earnest. He came to seeking the way many thoughtful people do: through a quiet sense that something essential was missing, a sense he could not explain to himself or to anyone close to him. He was, by every external measure, doing fine. The missing thing was not the kind of thing the external measures could see.</p>
            <p>Over the next two decades he moved, with seriousness, through Christianity, Buddhism, Vipassana, and several smaller traditions in between. He collected practices, certificates, and disciplines. He read the books, attended the retreats, sat the long sittings. He was a good student. The good studentship was part of the problem.</p>
            <p>The book is his attempt to write down, without performance and without the protective distance most spiritual memoirs hide behind, what those years cost — the marriage strained, the daughter who watched, the friends who quietly stopped asking how he was — and what they finally revealed.</p>
            <p>He lives in California with his wife and daughter. He does not teach, lead retreats, or take students. He wrote one book about a search that lasted most of his life, and that is the entire claim he makes.</p>
          </Reveal>
        </div>
      </section>

      <section data-testid="about-why-section" className="py-24 md:py-32" style={{ backgroundColor: "var(--paper)" }}>
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <Reveal><p className="overline mb-10">Why he wrote the book</p></Reveal>
          <Reveal delay={0.08}>
            <figure className="quote-block">
              <blockquote data-testid="about-quote" className="font-serif-lit italic text-2xl md:text-3xl leading-[1.5]">
                “I wrote this book because I needed to read it and could not find it. Most of the spiritual memoirs I read either ended in a clean recognition I did not believe, or they were written by people who seemed to have suffered less than I had. I wanted a book by someone who had genuinely been confused for a long time, and who eventually found something that worked, and who could write about it without making it sound easier than it was. When I could not find that book, I wrote it.”
              </blockquote>
              <figcaption className="mt-8 overline" style={{ color: "var(--ink-soft)" }}>— Rahul Bhaskar</figcaption>
            </figure>
          </Reveal>
        </div>
      </section>

      <section data-testid="about-not-section" className="py-24 md:py-32" style={{ backgroundColor: "var(--ink)", color: "var(--paper)" }}>
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <Reveal><p className="overline mb-8" style={{ color: "var(--warm)" }}>Three things this site is not</p></Reveal>
          <Reveal delay={0.08}>
            <p className="font-serif-lit text-2xl md:text-3xl leading-[1.6]">
              It is not a coaching site. It is not a course. It is not a path to a programme. It is the website of one book by one author, who is happy if you read it and would prefer not to be your teacher.
            </p>
          </Reveal>
        </div>
      </section>

      <EmailCapture testIdPrefix="about-newsletter" />
    </>
  );
}